<template>
  <div class="prestitial-cookie" style="display: none;" />
</template>
<script>
import cookies from 'js-cookie';

export default {
  props: {
    cookieName: {
      type: String,
      required: true,
    },
    cookieValue: {
      type: String,
      default: '0',
    },
    expires: {
      type: Number,
      default: 1,
    },
  },
  created() {
    this.addPrestitialDidServeListener();
  },
  methods: {
    // add event listener to drop a coockie anytime prestitial ad unit returns a creative.
    addPrestitialDidServeListener() {
      const { googletag } = window;
      googletag.cmd.push(() => {
        window.googletag.pubads().addEventListener('slotRenderEnded', (n) => {
          const slotElemId = n.slot.getSlotElementId();
          if (!slotElemId || !n.slot.getOutOfPage()) return;
          if (!n.isEmpty && n.slot.getAdUnitPath().includes('prestitial')) {
            cookies.set(this.cookieName, this.cookieValue, { expires: this.expires });
          }
        });
      });
    },
  },
};
</script>
